
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider.jsx";

// // ✅ Styles
// const containerStyle = {
//   width: window.innerWidth > 768 ? "100%" : "100%",
//   overflowX: "auto",
//   scrollbarWidth: "thin",
//   marginTop: "5px",
//   WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
// };

// const tableStyle = {
//   width: "100%",
//   borderCollapse: "collapse",
//   minWidth: "800px", // Ensure table has minimum width for horizontal scrolling
// };

// const thTdStyle = {
//   border: "1px solid #ddd",
//   textAlign: "center",
//   padding: "12px 8px",
//   fontSize: "14px",
// };

// const thStyle = {
//   ...thTdStyle,
//   backgroundColor: "#b15cd6",
//   color: "#fff",
//   fontWeight: "bold",
// };

// const WalletAdd = () => {
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const token = localStorage.getItem("authToken");
//   const vendorId = localStorage.getItem("vendorId");
//   const { showLoader, hideLoader } = useLoader();

//   // ✅ Fetch data from API
//   const fetchRequests = () => {
//     showLoader();
//     axios
//       .get(
//         `https://backend.maamaas.com/subscription/api/vendorApproval/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then((res) => setRequests(res.data || []))
//       .catch((err) => {
//         console.error("Error fetching wallet approvals:", err);
//         setRequests([]);
//       })
//       .finally(() => {
//         hideLoader();
//       });
//   };

//   useEffect(() => {
//     fetchRequests();
//   }, []);

//   // ✅ Approve request handler using PUT API
//   const handleApprove = (index) => {
//     const phoneNumber = requests[index].phoneNumber;

//     const payload = [
//       {
//         phoneNumber: phoneNumber,
//         vendorApproval: true,
//       },
//     ];

//     setLoading(true);

//     axios
//       .put(
//         `https://backend.maamaas.com/subscription/api/vendorApproval/update?vendorId=${vendorId}`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       )
//       .then((res) => {
//         const updatedRequests = [...requests];
//         updatedRequests[index].vendorApproval = true;
//         setRequests(updatedRequests);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error approving vendor:", err);
//         setLoading(false);
//       });
//   };

//   // Button style
//   const buttonStyle = {
//     backgroundColor: "#4CAF50",
//     color: "#fff",
//     border: "none",
//     padding: "5px 10px",
//     borderRadius: "5px",
//     cursor: loading ? "not-allowed" : "pointer",
//     opacity: loading ? 0.6 : 1,
//     fontSize: "12px",
//   };

//   return (
//     <div style={containerStyle}>
//       <table style={tableStyle}>
//         <thead>
//           <tr>
//             <th style={thStyle}>S.No</th>
//             <th style={thStyle}>User Name</th>
//             <th style={thStyle}>Company</th>
//             <th style={thStyle}>Restaurant</th>
//             <th style={thStyle}>Phone Number</th>
//             <th style={thStyle}>Post Paid</th>
//             <th style={thStyle}>Approved</th>
//             <th style={thStyle}>Credit Limit</th>
//             <th style={thStyle}>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {requests.length > 0 ? (
//             requests.map((req, index) => (
//               <tr key={index}>
//                 <td style={thTdStyle}>{index + 1}</td>
//                 <td style={thTdStyle}>{req.name}</td>
//                 <td style={thTdStyle}>{req.companyName}</td>
//                 <td style={thTdStyle}>{req.restaurentName}</td>
//                 <td style={thTdStyle}>{req.phoneNumber}</td>
//                 <td style={thTdStyle}>{req.postPaid ? "Yes" : "No"}</td>
//                 <td style={thTdStyle}>{req.vendorApproval ? "Yes" : "No"}</td>
//                 <td style={thTdStyle}>{req.creditLimit}</td>
//                 <td style={thTdStyle}>
//                   {!req.vendorApproval ? (
//                     <button
//                       onClick={() => handleApprove(index)}
//                       style={buttonStyle}
//                       disabled={loading}
//                     >
//                       {loading ? "Approving..." : "Approve"}
//                     </button>
//                   ) : (
//                     <span style={{ color: "green", fontWeight: "bold" }}>
//                       Approved
//                     </span>
//                   )}
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="9" style={{ ...thTdStyle, textAlign: "center" }}>
//                 No data available
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default WalletAdd;







import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";

const WalletAdd = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const token = localStorage.getItem("authToken");
  const vendorId = localStorage.getItem("vendorId");
  const { showLoader, hideLoader } = useLoader();

  // Set default dates in YYYY-MM-DD format
  useEffect(() => {
    const today = new Date();
    const weekAgo = new Date();
    weekAgo.setDate(today.getDate() - 7);

    // Format as YYYY-MM-DD
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const fromDateStr = formatDate(weekAgo);
    const toDateStr = formatDate(today);

    setFromDate(fromDateStr);
    setToDate(toDateStr);

    // Fetch data with default dates on component mount
    fetchDataWithDates(fromDateStr, toDateStr);
  }, []);

  // Fetch data function with parameters
  const fetchDataWithDates = (from, to) => {
    if (!vendorId) {
      return;
    }

    if (!from || !to) {
      return;
    }

    // Validate date format is YYYY-MM-DD
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(from) || !dateRegex.test(to)) {
      return;
    }

    if (new Date(from) > new Date(to)) {
      return;
    }

    showLoader();
    setLoading(true);


    axios
      .get(
        `https://backend.maamaas.com/food/api/ledger/vendor/${vendorId}/range?fromDate=${from}&toDate=${to}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      )
      .then((res) => {
        if (Array.isArray(res.data)) {
          setData(res.data);
        } else {
          setData([]);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        console.error("Error response:", err.response?.data);
        setData([]);
      })
      .finally(() => {
        hideLoader();
        setLoading(false);
      });
  };

  // Fetch data with current state dates
  const fetchData = () => {
    fetchDataWithDates(fromDate, toDate);
  };

  // Handle date change and auto-fetch
  const handleFromDateChange = (e) => {
    const newFromDate = e.target.value;
    setFromDate(newFromDate);
    // Auto-fetch when both dates are valid
    if (newFromDate && toDate && new Date(newFromDate) <= new Date(toDate)) {
      fetchDataWithDates(newFromDate, toDate);
    }
  };

  const handleToDateChange = (e) => {
    const newToDate = e.target.value;
    setToDate(newToDate);
    // Auto-fetch when both dates are valid
    if (fromDate && newToDate && new Date(fromDate) <= new Date(newToDate)) {
      fetchDataWithDates(fromDate, newToDate);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Filter Section */}
      <div style={{ marginBottom: "20px" }}>
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div>
            <div style={{ marginBottom: "5px", fontSize: "14px" }}>From Date</div>
            <input
              type="date"
              value={fromDate}
              onChange={handleFromDateChange}
              max={new Date().toISOString().split('T')[0]} // 👈 Disable future dates
              style={{
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                minWidth: "150px"
              }}
            />
          </div>

          <div>
            <div style={{ marginBottom: "5px", fontSize: "14px" }}>To Date</div>
            <input
              type="date"
              value={toDate}
              onChange={handleToDateChange}
              max={new Date().toISOString().split('T')[0]} // 👈 Disable future dates
              style={{
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                minWidth: "150px"
              }}
            />
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div style={{ overflowX: "auto", borderRadius: "6px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#b15cd6" }}>
              <th style={{
                border: "1px solid #9a4bc2",
                padding: "14px 12px",
                textAlign: "left",
                color: "white",
                fontSize: "15px",
                fontWeight: "700",
                borderTopLeftRadius: "6px",
                textAlign: "center",
                verticalAlign: "middle"
              }}>
                Company Name
              </th>
              <th style={{
                border: "1px solid #9a4bc2",
                padding: "14px 12px",
                textAlign: "left",
                color: "white",
                fontSize: "15px",
                fontWeight: "700",
                textAlign: "center",
                verticalAlign: "middle"
              }}>
                Restaurant Name
              </th>
              <th style={{
                border: "1px solid #9a4bc2",
                padding: "14px 12px",
                textAlign: "left",
                color: "white",
                fontSize: "15px",
                fontWeight: "700",
                borderTopRightRadius: "6px",
                textAlign: "center",
                verticalAlign: "middle"
              }}>
                Total Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3" style={{
                  border: "1px solid #e0e0e0",
                  padding: "40px 20px",
                  textAlign: "center",
                  color: "#666",
                  backgroundColor: "#f9f9f9",
                  fontSize: "15px",
                  textAlign: "center",
                  verticalAlign: "middle"
                }}>
                  Loading data...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan="3" style={{
                  border: "1px solid #e0e0e0",
                  padding: "40px 20px",
                  textAlign: "center",
                  color: "#666",
                  backgroundColor: "#f9f9f9",
                  fontSize: "15px",
                  textAlign: "center",
                  verticalAlign: "middle"
                }}>
                  No data available for {fromDate} to {toDate}
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8f8f8",
                  transition: "background-color 0.2s"
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f0f0f0";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#ffffff" : "#f8f8f8";
                  }}>
                  <td style={{
                    border: "1px solid #e0e0e0",
                    padding: "12px",
                    fontSize: "14px",
                    color: "#333",
                    textAlign: "center",
                    verticalAlign: "middle"
                  }}>
                    {item.companyName || "-"}
                  </td>
                  <td style={{
                    border: "1px solid #e0e0e0",
                    padding: "12px",
                    fontSize: "14px",
                    color: "#333",
                    textAlign: "center",
                    verticalAlign: "middle"
                  }}>
                    {item.restaurantName || "-"}
                  </td>
                  <td style={{
                    border: "1px solid #e0e0e0",
                    padding: "12px",
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#2e7d32",
                    textAlign: "center",
                    verticalAlign: "middle"
                  }}>
                    ₹{item.totalAmount ? item.totalAmount.toFixed(2) : "0.00"}
                  </td>
                </tr>
              ))
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
};

export default WalletAdd;